module.exports = __webpack_public_path__ + "img/11.ac3c664b.svg";